import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Don't show breadcrumbs on home page
  if (location.pathname === '/') {
    return null;
  }

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://vastulens.com' },
      ...pathnames.map((name, index) => ({
        '@type': 'ListItem',
        position: index + 2,
        name: name.charAt(0).toUpperCase() + name.slice(1).replace(/-/g, ' '),
        item: `https://vastulens.com/${pathnames.slice(0, index + 1).join('/')}`,
      })),
    ],
  };

  return (
    <div style={breadcrumbsContainerStyle}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <div className="container">
        <ul style={breadcrumbsListStyle}>
          <li>
            <Link to="/" style={linkStyle}>Home</Link>
          </li>
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            
            // Format name: capitalize first letter, replace hyphens with spaces
            const formattedName = name.charAt(0).toUpperCase() + name.slice(1).replace(/-/g, ' ');

            return (
              <li key={name} style={{ display: 'flex', alignItems: 'center' }}>
                <span style={separatorStyle}>&gt;</span>
                {isLast ? (
                  <span style={activeStyle}>{formattedName}</span>
                ) : (
                  <Link to={routeTo} style={linkStyle}>{formattedName}</Link>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

const breadcrumbsContainerStyle = {
  backgroundColor: 'var(--color-bg)',
  padding: '1rem 0 0.5rem',
  fontSize: '0.85rem',
  color: 'var(--color-text-light)',
  borderBottom: '1px solid transparent' // Optional subtle border if needed
};

const breadcrumbsListStyle = {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap'
};

const linkStyle = {
  color: 'var(--color-text-light)',
  textDecoration: 'none',
  transition: 'color 0.2s'
};

const activeStyle = {
  color: 'var(--color-text)', // Darker color for current page
  fontWeight: '600'
};

const separatorStyle = {
  margin: '0 0.5rem',
  color: 'var(--color-text-light)',
  opacity: 0.7
};

export default Breadcrumbs;
